export default __webpack_public_path__ + "static/media/4d.6e77549a.png";